import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

export const COLLECTIONS = ["clientes", "articulos", "servicios", "personal", "proyectos", "ventas"];

const TOKEN_KEY = "convitel_auth_token";

export const authStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

// Axios instance with interceptor
const http = axios.create({ baseURL: API_BASE });

http.interceptors.request.use((cfg) => {
  const t = authStore.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Callback set by AuthContext to handle 401 globally (logout)
let on401Handler = null;
export const setOn401 = (fn) => (on401Handler = fn);

http.interceptors.response.use(
  (r) => r,
  (err) => {
    // Auto-logout on 401 ONLY when the session token is actually invalid.
    // For endpoints that legitimately return 401 on user input errors
    // (wrong login / wrong current password), don't kick the user out.
    const url = err?.config?.url || "";
    const isInputAuthError =
      url.includes("/auth/login") || url.includes("/auth/change-password");
    if (err?.response?.status === 401 && !isInputAuthError) {
      if (on401Handler) on401Handler();
    }
    return Promise.reject(err);
  }
);

export const api = {
  base: API_BASE,
  http,
  // list now returns { items, total, skip, limit }
  async list(col, { skip = 0, limit = 1000 } = {}) {
    const { data } = await http.get(`/${col}`, { params: { skip, limit } });
    return data;
  },
  async create(col, payload) {
    const { data } = await http.post(`/${col}`, payload);
    return data;
  },
  async update(col, id, payload) {
    const { data } = await http.put(`/${col}/${id}`, payload);
    return data;
  },
  async remove(col, id) {
    await http.delete(`/${col}/${id}`);
  },
  async login(email, password) {
    const { data } = await http.post(`/auth/login`, { email, password });
    return data;
  },
  async me() {
    const { data } = await http.get(`/auth/me`);
    return data;
  },
  async changePassword(current, next) {
    const { data } = await http.post(`/auth/change-password`, { current, new: next });
    return data;
  },
  async seed() {
    const { data } = await http.post(`/seed`, {});
    return data;
  },
  async backup() {
    const { data } = await http.get(`/backup/all`);
    return data;
  },
  async restore(payload) {
    const { data } = await http.post(`/backup/restore`, payload);
    return data;
  },
};
